import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdatePlaylistItemDocument } from './update.generated';

export const useUpdatePlaylistItem = (
  options: ApiOptions<typeof UpdatePlaylistItemDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(UpdatePlaylistItemDocument, {
    ...useNotifications(UpdatePlaylistItemDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.playlist_items.update_success'),
    }),
    ...options,
  });
};
